import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from '@app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CompanyHiringComponent } from './pages/company-hiring/company-hiring.component';
import { Page6DataConfirmComponent } from './components/page6-data-confirm/page6-data-confirm.component';
import { ListCompaniesComponent } from './pages/list-companies/list-companies.component';
import { FileCompanyAdminComponent } from './pages/file-company-admin/file-company-admin.component';
import { DataCompanyAdminComponent } from './components/data-company-admin/data-company-admin.component';
import { InfoCompanyComponent } from './components/info-company/info-company.component';
import { HeaderCompanyComponent } from './components/header-company/header-company.component';
import { CompanyModule } from '@app/private/company/company.module';




@NgModule({
  declarations: [
    CompanyHiringComponent,   
    Page6DataConfirmComponent,
    ListCompaniesComponent,
    FileCompanyAdminComponent,
    DataCompanyAdminComponent,
    InfoCompanyComponent,
    HeaderCompanyComponent,
   
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    CompanyModule
   
  ],
  exports: [
    InfoCompanyComponent,
    HeaderCompanyComponent
  ],
})
export class CompanyAdminModule { }
